import { render } from "./MOSSBotSettings.vue?vue&type=template&id=3ea638a2"
import script from "./MOSSBotSettings.vue?vue&type=script&lang=js"
export * from "./MOSSBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__